import { Router } from '@angular/router';
import { AppConfigService } from './app-config.service';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { getErrorMessage, getWarningrMessage } from '../shared/utilities';
import { ResponseTypeEnum } from '../models/enums';
import { Globals } from '../shared/globals';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./app-config.service";
import * as i3 from "@angular/router";
import * as i4 from "../shared/globals";
var BaseHttpService = /** @class */ (function () {
    function BaseHttpService(http, appConfig, router, globals) {
        var _this = this;
        this.http = http;
        this.appConfig = appConfig;
        this.router = router;
        this.globals = globals;
        this.Post = function (url, entity, responseType) {
            if (responseType === void 0) { responseType = 1; }
            url = _this.appConfig.settings.apiServerURL + url;
            return _this.http.post(url, entity, { headers: _this.headers })
                .pipe(map(function (res) {
                return _this.getResponse(res, responseType);
            }), catchError(_this.handleError));
        };
        this.Get = function (url, responseType) {
            if (responseType === void 0) { responseType = 1; }
            url = _this.appConfig.settings.apiServerURL + url;
            return _this.http.get(url, { headers: _this.headers })
                .pipe(map(function (res) {
                return _this.getResponse(res, responseType);
            }), catchError(_this.handleError));
        };
        this.Delete = function (url, responseType, params) {
            if (responseType === void 0) { responseType = 1; }
            url = _this.appConfig.settings.apiServerURL + url;
            return _this.http.delete(url, { headers: _this.headers, params: params })
                .pipe(map(function (res) {
                return _this.getResponse(res, responseType);
            }), catchError(_this.handleError));
        };
        this.getResponse = function (res, responseType) {
            if (responseType == ResponseTypeEnum.Result || responseType == ResponseTypeEnum.Success) {
                if (!res.success) {
                    _this.handleUserFriendlyError(res.userFriendlyErrorMessage, res.errorMessages);
                }
                else if (res.success && res.userFriendlyWarningMessage) {
                    getWarningrMessage(res.userFriendlyWarningMessage);
                }
                return responseType == ResponseTypeEnum.Result ? res.result : res.success;
            }
            else {
                return res;
            }
        };
        this.handleError = function (err) {
            if (err.status === 401) {
                //auto logout if 401 response returned from api
                _this.globals.isLoogedIn = false;
                localStorage.removeItem('Authorization');
                _this.router.navigate(['login']);
            }
            else {
                getErrorMessage();
            }
            return throwError(err);
        };
        this.handleUserFriendlyError = function (userFriendlyError, backendError) {
            if (userFriendlyError) {
                getErrorMessage(userFriendlyError);
                console.error('User Friendly Error Message - ', userFriendlyError || 'Unknown Error');
            }
            else {
                getErrorMessage();
                console.error('Backend Error Message - ', backendError || 'Unknown Error');
            }
        };
        this.buildParamsFromList = function (ids, paramName) {
            var params = [];
            ids.forEach(function (id) {
                params.push(paramName + "=" + id);
            });
            return params.join('&');
        };
        this.getFile = function (url, callback) {
            if (callback === void 0) { callback = null; }
            var client = new XMLHttpRequest();
            client.open('GET', url, true);
            client.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
            client.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem("Authorization"));
            client.setRequestHeader('Year', localStorage.getItem("Version") || ((new Date).getFullYear()).toString());
            client.responseType = 'blob';
            client.onload = function (e) {
                if (client.status === 200) {
                    // Try to find out the filename from the content disposition `filename` value
                    var filename = "";
                    var disposition = client.getResponseHeader('Content-Disposition');
                    if (disposition && disposition.indexOf('filename') !== -1) {
                        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        var matches = filenameRegex.exec(disposition);
                        if (matches != null && matches[1]) {
                            filename = matches[1].replace(/['"]/g, '');
                        }
                    }
                    var contentType = client.getResponseHeader('Content-Type');
                    // The actual download
                    var blob = new Blob([client.response], { type: contentType });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    if (callback) {
                        callback();
                    }
                }
            };
            client.send();
        };
    }
    Object.defineProperty(BaseHttpService.prototype, "headers", {
        get: function () {
            return new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("Authorization"),
                'Year': localStorage.getItem("Version") || ((new Date).getFullYear()).toString()
            });
        },
        enumerable: true,
        configurable: true
    });
    BaseHttpService.ngInjectableDef = i0.defineInjectable({ factory: function BaseHttpService_Factory() { return new BaseHttpService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfigService), i0.inject(i3.Router), i0.inject(i4.Globals)); }, token: BaseHttpService, providedIn: "root" });
    return BaseHttpService;
}());
export { BaseHttpService };
